export default __webpack_public_path__ + "static/media/login.b5b25746.jpg";